import { z } from 'zod';
import { UserHeader } from './types';
import { HeaderZodValidators } from '@agilelab/plugin-wb-platform-common';

/**
 * @returns a list of error objects (if any)
 */
export const validateHeader = (
  header: UserHeader,
): { field?: string; errors: string[] }[] => {
  const validator = z.object({
    name: HeaderZodValidators.name,
    value: HeaderZodValidators.value,
    isSensitive: z.boolean(),
  });
  const validationRes = validator.safeParse(header);
  if (!validationRes.success) {
    const errors = validationRes.error.format();
    const nameErrors = errors.name
      ? [
          {
            field: 'name',
            errors: errors.name!._errors,
          },
        ]
      : [];
    const valueErrors = errors.value
      ? [
          {
            field: 'value',
            errors: errors.value!._errors,
          },
        ]
      : [];
    return [...nameErrors, ...valueErrors];
  }
  return [];
};
